import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CardColor {

    public getCardColorBlue(price:number,clientType:string):string{
        /*Inmobiliaria
        $: 0 - 300.000 ( Azul claro)
        $300.001- 450.000 ( azul medio)
        $450.001- En adelante ( Azul oscuro)

        Rango de colores: agente
        $: 0 - 200.000 ( Azul claro)
        $200.001- 350.000 ( Azul medio)
        $350.001- En adelante ( Azul oscuro)
*/
        let color:string = '';
        
        switch (clientType){
            //Inmobiliaria
            case '1':
                if(price >= 0 && price <= 255000){
                    color = 'planBasic';
                }
                if(price > 255000 && price <= 310000){
                    color = 'planBasicPLus';
                }
                if(price > 310000 && price <= 500000){
                    color = 'planS';
                }
                if(price > 500000 && price <=790000){
                    color = 'planM';
                }
                if(price > 790000){
                    color = 'planL';
                }
                break;
            //Agente
            case '2':
                if(price >= 0 && price <= 100000){
                    color = 'planXSAgente';
                }
                if(price > 100000 && price <= 200000){
                    color = 'planSAgente';
                }
                if(price > 200000 && price <= 350000){
                    color = 'bg-gradient-green-2';
                }
                if(price > 350000){
                    color = 'bg-gradient-blue-2';
                }
                break;
            //Constructora
            case '3':
                if(price >= 0 && price <= 358000){
                    color = 'bg-gradient-grey-1';
                }
                if(price > 358000 && price <= 379000){
                    color = 'bg-gradient-blue-1';
                }
                if(price > 379000 && price <= 393000){
                    color = 'bg-gradient-blue-2';
                }
                if(price > 393000){
                    color = 'bg-gradient-blue-3';
                }
                break;
            default:
                break;
        }

       
        return color;
    }

    public getCardColorGreen(price:number,clientType:string):string{
        /*Constructora:
        verde oscuro 390.000
        verde claro 381.000
        azul oscuro 368.000
        gris oscuro 348.000
*/
        let color:string = '';
        
        switch (clientType){
            //Constructora
            case '3':
                if(price >= 0 && price <= 348000){
                    color = 'bg-gradient-grey-1';
                }
                if(price > 348000 && price <= 368000){
                    color = 'bg-gradient-blue-1';
                }
                if(price > 368000 && price <= 381000){
                    color = 'bg-gradient-green-2';
                }
                if(price > 381000){
                    color = 'bg-gradient-green-3';
                }
                break;
            default:
                break;
        }
        return color;
    }
}